import React from "react";
import ContributeContainer from "../../components/contributeContainer/ContributeContainer";
import "./Contribute.css";

function Contribute() {
  const contributeBoxData = [
    {
      id: 0,
      img: "keyword.png",
      title: "Guidestar Transparency Key",
      content: "keyword content...",
    },
    {
      id: 1,
      img: "award.png",
      title: "India Sustainability Leadership Awards Certificate of Merit 2018",
      content: "award content...",
    },
    {
      id: 2,
      img: "donate.png",
      title: "FCRA & 80G",
      content: "donate content...",
    },
    {
      id: 3,
      img: "report.png",
      title: "Third party Audited Accounts",
      content: "report content...",
    },
  ];
  return (
    <div className="contribute_main_container" style={{ height: "85vh" }}>
      <div className="contribute_header_container"></div>
      <div className="contribute_header">Contribute to Women Wings</div>
      <div className="contribute_sub_header">
        There are many reasons why 56 companies and 155 individuals have choosen
        to contrbute to Women Wings.
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ContributeContainer data={contributeBoxData} />
      </div>
    </div>
  );
}

export default Contribute;
